import type { FaireProductEntity } from "../../entity_types/product";

export const p_nbpfzw66rp: FaireProductEntity = {
  token: "p_nbpfzw66rp",
  type: "product",
  name: "DECAF SINGLE ORIGIN",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/7dc4ea19a565123153fd6623782f071ab14e1d4c06b03221be3e348c3b67e9e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36ba9fa76fab9e819602695d8589f8c3fceca6199d538a2380e8d0776e3a1525.jpeg"
  ],
  priceDollars: 12.25,
  description: "Rotating Decaf Single Origin: Mexico Tonga 5\n\nThis deliciously sweet and fully washed coffee traveled from Chiapas, Mexico to Oakland for tasting, then to Canada for Swiss water processing, then... here. Carob, chocolate and navel orange flavors await you.\n\n\n\n\n\n\n",
  tags: [],
  msrpDollars: 24.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:06.048Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
